export const radiusOptions = [5, 10, 20, 50];
export const popularKeywords = [
  'Cashier',
  'Housekeeper',
  'Sales',
  'Forklift',
  'Warehouse',
  'Driver',
];
